import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServerService } from '../../service/server/server.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import Num2persian from 'num2persian';


@Component({
  selector: 'app-ckd-material-list',
  templateUrl: './ckd-material-list.component.html',
  styleUrls: ['./ckd-material-list.component.scss']
})
export class CkdMaterialListComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  title: string | undefined;
  lang: any = 1;
  id: number | undefined;
  list_record: any = [];
  list_record_length = 1;
  user_info: any | undefined;
  user_id: number | undefined;
  search: string;
  cate: number | undefined;
  form1: FormGroup;
  ckd_id: number | undefined;
  sum_final: number = 0;
  sum_final_letter: string | undefined;
  seleton_id: number | undefined;
  sum_all: number = 0;
  discount_all: number = 0;
  sum_with_discount: number = 0;
  tax: number = 0;



  mat_table_selectedRow: any;
  public dataSource: any | undefined;
  displayedColumns = ['row', 'image', 'title', 'cate2', 'number', 'price', 'sum', 'discount', 'sum_with_discount', 'tax', 'zarayeb', 'sum_final'];


  constructor(public serverService: ServerService, public router: Router, private matSnackBar: MatSnackBar
    , private matDialogRef: MatDialogRef<CkdMaterialListComponent>, private dialog: MatDialog
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    if (dialog_data) {
      this.id = dialog_data.id;
      this.cate = dialog_data.cate;
      this.title = dialog_data.title;
      this.ckd_id = dialog_data.ckd_id;
      this.seleton_id = dialog_data.seleton_id;
    }

  }//end consructor

  ngOnInit() {
    this.lang = localStorage.getItem('lang');
    this.user_info = JSON.parse(<any>localStorage.getItem("user_info"));
    this.user_id = this.user_info.user_id;
    this.form1 = new FormGroup({
      'material': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')]),
      'material_title': new FormControl(null),
      'cate2_title': new FormControl(null),
      'cate2': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')])
    })
    this.get_material(1);
  }

  check_access(type_task: number, page: number, id: any, excel: number, loading: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: 222 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_material(type: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 10570, ckd_id: this.ckd_id, seleton_id: this.seleton_id }).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            res['result'][i].logo = res['result'][i].wharehouse_material_site + "/" + res['result'][i].wharehouse_material_logo;
            res['result'][i].sum_with_discount = res['result'][i].sum_all - res['result'][i].wharehouse_order_discount;
            res['result'][i].tax = Math.round(res['result'][i].sum_with_discount * 9 / 100);
            res['result'][i].sum_final = res['result'][i].sum_with_discount + res['result'][i].tax;

            this.sum_all = this.sum_all + res['result'][i].sum_all;
            this.discount_all = this.discount_all + res['result'][i].wharehouse_order_discount;
            this.sum_with_discount = this.sum_all - this.discount_all;
            this.tax = Math.round(this.sum_with_discount * 9 / 100);
            this.sum_final += res['result'][i].sum_final;
            this.list_record.push(res['result'][i]);
          }
          this.sum_final_letter = Num2persian(this.sum_final);
          this.dataSource = new MatTableDataSource(this.list_record)
          this.recieve_message(false, "", "", 1, "", "");
        }//end if 
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  get_bg(row_id: number) {
    //this.row_id = row_id;
  }

  select(id: number, title: string) {
    this.matDialogRef.close({ id: id, title: title });
  }//end select

  //*******************************************************************************
  close() {
    this.matDialogRef.close();
  }

  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      this.matSnackBar.dismiss();
    }
  }

  message(validation: boolean, message: string, type: number, action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}